import React, { useState, useEffect, useRef } from 'react';
import './GlobalStyle.css'
import clsx from 'clsx';
import NotFound from '../../../Images/notFound.png';
import { Paper, makeStyles, TableBody, TableRow, TableCell, Button, IconButton, Tooltip, CircularProgress, Divider, Menu, MenuItem } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility'
import useTable from '../../useTable';
import SearchIcon from '@material-ui/icons/Search';
import CheckUserProvider from '../../../AllHooks/CheckUserProvider';
import { useHistory } from 'react-router-dom';
import CustomAlert from '../../CustomAlert';
import { Helmet } from 'react-helmet';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import * as XLSX from 'xlsx';
import { getSupplyBillsDocumentWithUserId } from '../../../Backend/firebase/supply-bills';
import { extractNumber } from '../../../mock';
import Popup from '../../Popup';
import { parseDate } from '../../Models/CommonFunc';


const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        width: '100%'
    },
    fixedHeight: {
        height: '100%',
    },
}));

const headCells = [
    { id: 'InvoiceDate', label: 'Invoice Date', disableSorting: false },
    { id: 'Party', label: 'Party Details', disableSorting: false },
    { id: 'InvoiceNo', label: 'Invoice No', disableSorting: false },
    { id: 'ProductName', label: 'Product Name', disableSorting: true },
    // { id: 'BatchNo', label: 'Batch No', disableSorting: false },
    // { id: 'Quantity', label: 'Quantity', disableSorting: false },
    // { id: 'ProductMRP', label: 'MRP', disableSorting: false },
    { id: 'GrossValue', label: 'Amount', disableSorting: false },
    { id: 'action', label: 'Action', disableSorting: false }
]

function SupplyOrderBillsHistory() {
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const { userData } = CheckUserProvider();
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const [searchChange, setSearchChange] = useState(false);
    const [pageAfterSearch, setPageAfterSearch] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } = useTable(records, headCells, filterFn,
        searchChange, pageAfterSearch);
    const history = useHistory();
    const [openNotify, setOpenNotify] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [totalAmount, setTotalAmount] = useState(0);
    const [alertType, setAlertType] = useState('');
    const [anchorElForExcel, setAnchorElForExcel] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openPopup, setOpenPopup] = useState(false);
    const [tableInvoiceRef, setTableInvoiceRef] = useState({});
    const tableRef = useRef();
    const xlsxTableRef = useRef();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClickForExcel = (event) => {
        setAnchorElForExcel(event.currentTarget);
    };

    const handleCloseForExcel = () => {
        setAnchorElForExcel(null);
    };

    const handleSearch = (e) => {
        let target = e.target;
        if (target.value === '') {
            setSearchChange(false);
            setPageAfterSearch(false);
        } else {
            setSearchChange(true);
            setPageAfterSearch(true);
        }
        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(item => {
                        const storeInfo = `${(item?.storeName || item?.chemistEntry?.storeName)} ${(item?.storeAddress || item?.chemistEntry?.storeAddress)}`;
                        return storeInfo.toLowerCase().includes(target.value.toLowerCase());
                    });
                }
            }
        });
    };


    useEffect(async () => {
        if (userData) {
            setIsLoading(true);
            try {
                const getSupplyBills = await getSupplyBillsDocumentWithUserId(userData?.uid);
                const sortedBills = getSupplyBills.sort((a, b) => {
                    return parseDate(b.SupplyBillsPostedDateTime) - parseDate(a.SupplyBillsPostedDateTime);
                });
                setTotalAmount(sortedBills.reduce((accumulator, object) => {
                    return Number(accumulator) + Number(object.TotalAmount)
                }, 0))
                setRecords(sortedBills);
                setIsLoading(false);
            } catch (error) {
                console.log("Error Occur in Get Sales Bills", error)
                setIsLoading(false);
            }
        }
    }, [userData]);

    const editInvoice = (invoice) => {
        if (!invoice || Object.keys(invoice).length === 0) {
            console.error("Invoice data is missing or empty.");
            return;
        }

        const updatedInvoice = {
            ...invoice,
            lastEdited: new Date().toISOString(), // Add a timestamp if needed
        };
        localStorage.setItem('invoiceRecord', JSON.stringify(updatedInvoice));
        history.push('/supply/edit-order-generate-invoice');
    };

    const convertToSlug = (input) => input?.toLowerCase()?.replace(/[^a-z0-9\s]/g, '')?.replace(/\s+/g, '_');
    const viewInvoice = (invoice) => {
        if (!invoice || Object.keys(invoice).length === 0) {
            console.error("Invoice data is missing or empty.");
            return;
        }

        const updatedInvoice = {
            ...invoice,
            lastEdited: new Date().toISOString(), // Add a timestamp if needed
        };
        setTableInvoiceRef(updatedInvoice);
        setOpenPopup(true);
    };

    const downloadInvoice = () => {
        const tableElement = tableRef.current;
        if (!tableElement) return;

        html2canvas(tableElement).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "mm", "a4");

            const imgWidth = 190; // Full width for A4
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);

            // Convert PDF to Blob URL for preview
            const pdfBlob = pdf.output("blob");
            const pdfUrl = URL.createObjectURL(pdfBlob);

            // Open PDF in new tab
            window.open(pdfUrl, "_blank");
        });
    };

    const downloadInvoiceinXLSX = () => {
        const dataTableElement = xlsxTableRef.current;
        if (!dataTableElement) return;
    
        const wb = XLSX.utils.book_new();
    
        const InvoiceInfo = [
            [
                "Butame Pharma India Pvt. Ltd.",
                "",
                "",
                "Party Name:",
                tableInvoiceRef?.storeName || tableInvoiceRef?.chemistEntry?.storeName || "NA",
                "",
            ],
            [
                userData?.storeAddress || "",
                "",
                "",
                "Invoice No:",
                tableInvoiceRef?.InvoiceNo || "NA",
                "",
            ],
            [
                `Contact No: ${userData?.phoneNumber || ""}`,
                "",
                "",
                "Invoice Date:",
                tableInvoiceRef?.InvoiceDate || "NA",
                "",
            ],
            [
                `Email Id: ${userData?.email || "NA"}`,
                "",
                "",
                "",
                "",
                "",
            ],
            [
                `GST No: ${userData?.gstNo || "NA"}`,
                "",
                "",
                "",
                "",
                "",
            ],
            [
                `DL No: ${userData?.drugLicense || "NA"}`,
                "",
                "",
                "",
                "",
                "",
            ],
            [], // Empty row for spacing
        ];
    
        // Merging cells by groups of three columns
        const finalWs = XLSX.utils.aoa_to_sheet(InvoiceInfo);
    
        // Merge cells clearly for better visual presentation
        finalWs["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: 2 } },
            { s: { r: 1, c: 0 }, e: { r: 1, c: 2 } },
            { s: { r: 2, c: 0 }, e: { r: 2, c: 2 } },
            { s: { r: 3, c: 0 }, e: { r: 3, c: 2 } },
            { s: { r: 4, c: 0 }, e: { r: 4, c: 2 } },
            { s: { r: 5, c: 0 }, e: { r: 5, c: 2 } },
    
            { s: { r: 0, c: 4 }, e: { r: 0, c: 5 } },
            { s: { r: 1, c: 4 }, e: { r: 1, c: 5 } },
            { s: { r: 2, c: 4 }, e: { r: 2, c: 5 } },
        ];
    
        // Now your existing logic for main table (dataTableElement)
        const ws = XLSX.utils.table_to_sheet(dataTableElement, { raw: true });
    
        // Your existing headerData logic remains untouched
        const header = dataTableElement.querySelectorAll('thead tr');
        const headerData = Array.from(header).map(row => {
            return Array.from(row.querySelectorAll('td')).map(cell => cell.innerText);
        });
    
        if (headerData.length > 0) {
            const range = XLSX.utils.decode_range(ws['!ref']);
            for (let i = 0; i < headerData.length; i++) {
                const rowIndex = range.s.r - headerData.length + i;
                headerData[i].forEach((cell, j) => {
                    const cellAddress = { r: rowIndex, c: j };
                    ws[XLSX.utils.encode_cell(cellAddress)] = { v: cell };
                });
            }
        }
    
        const dataJson = XLSX.utils.sheet_to_json(ws, { header: 1 });
    
        // Combine InvoiceInfo and main table data
        const finalSheetData = [...InvoiceInfo, ...dataJson];
    
        // Create final worksheet clearly again to include all combined data and merges
        const completeFinalWs = XLSX.utils.aoa_to_sheet(finalSheetData);
    
        // Re-apply merge rules to the complete worksheet
        completeFinalWs["!merges"] = finalWs["!merges"];
    
        // Append final worksheet
        XLSX.utils.book_append_sheet(wb, completeFinalWs, "Invoice");
    
        const fileName = tableInvoiceRef?.storeName
            ? `${convertToSlug(tableInvoiceRef.storeName)}.xlsx`
            : tableInvoiceRef?.chemistEntry?.storeName
                ? `${convertToSlug(tableInvoiceRef.chemistEntry.storeName)}.xlsx`
                : "invoice.xlsx";
    
        XLSX.writeFile(wb, fileName);
    };
    

    return (
        <>
            {!userData || isLoading ?
                (<div className="row">
                    <div className="col-md-12 text-center p-4">
                        <CircularProgress />
                    </div>
                </div>) :
                (<div className="allProductsAndSales">
                    <Paper className={fixedHeightPaper}>
                        <Helmet>
                            <meta name="description" content="Find Supply Bills you have posted till now." />
                            <title>Supply Bills | Kaipsool Pharmatech</title>
                        </Helmet>
                        <div className="row d-flex justify-content-center align-items-center">
                            <div className="col-md-8">
                                <div className="display-inline">
                                    <div className="allProducts__productStatusContent allProducts__flexContent mr-4">
                                        <Button
                                            variant="contained"
                                            className="employerIndex__createPostBtn employerIndex__createProduct black"
                                            onClick={handleClickForExcel}
                                        >
                                            Generate Invoice
                                        </Button>
                                        <Menu anchorEl={anchorElForExcel} open={Boolean(anchorElForExcel)} onClose={handleClose}
                                            anchorOrigin={{
                                                vertical: "bottom",
                                                horizontal: "left",
                                            }}
                                            transformOrigin={{
                                                vertical: "top",
                                                horizontal: "left",
                                            }}>
                                            <MenuItem
                                                onClick={() => {
                                                    history.push("/supply/generate-excel-invoice");
                                                    handleCloseForExcel();
                                                }}
                                            >
                                                Generate Invoice From Excel
                                            </MenuItem>
                                            <MenuItem
                                                onClick={() => {
                                                    history.push("/supply/generate-invoice");
                                                    handleCloseForExcel();
                                                }}
                                            >
                                                Generate Normal Invoice
                                            </MenuItem>
                                        </Menu>
                                    </div>
                                    <div className="allProducts__productStatusContent allProducts__flexContent">
                                        <Button
                                            variant="contained"
                                            className="employerIndex__createPostBtn employerIndex__createProduct green"
                                            onClick={handleClick}
                                        >
                                            Excel Invoices
                                        </Button>
                                        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}
                                            anchorOrigin={{
                                                vertical: "bottom",
                                                horizontal: "left",
                                            }}
                                            transformOrigin={{
                                                vertical: "top",
                                                horizontal: "left",
                                            }}>
                                            <MenuItem
                                                onClick={() => {
                                                    history.push("/supply/upload-excel-invoice");
                                                    handleClose();
                                                }}
                                            >
                                                Upload New Invoice
                                            </MenuItem>
                                            <MenuItem
                                                onClick={() => {
                                                    history.push("/supply/all-excel-invoices");
                                                    handleClose();
                                                }}
                                            >
                                                View All Invoices
                                            </MenuItem>
                                        </Menu>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="d-flex justify-content-center w-100 align-items-center allProductsTable__searchBox">
                                    <SearchIcon className="mr-2" />
                                    <input type="text" placeholder="Search Supply Bills..." className="border-0"
                                        onChange={handleSearch} />
                                </div>
                            </div>
                            {records.length > 0 ? <div className="row col-md-12">
                                <div className="card-events-body d-flex flex-column mt-3">
                                    <div className="card-events-details-popup">
                                        {/* {<h6 className="card-events-title product__mainTitle">Total Quantity: <b>{quantity}</b></h6>} */}
                                        {<h6 className="card-events-title product__mainTitle">Total Sales Value: <b>{`Rs. ${totalAmount?.toFixed(2)}`}</b></h6>}
                                    </div>
                                </div>
                                <TblContainer>
                                    <TblHead />
                                    <TableBody>
                                        {
                                            recordsAfterPagingAndSorting().map(item => (
                                                <TableRow key={item.id}>
                                                    <TableCell>{item.InvoiceDate}</TableCell>
                                                    <TableCell>{`${(item?.storeName || item?.chemistEntry?.storeName)} ${(item?.storeAddress || item?.chemistEntry?.storeAddress)}`}</TableCell>
                                                    <TableCell>{item.InvoiceNo ? item.InvoiceNo : "NA"}</TableCell>
                                                    <TableCell>
                                                        {item?.ProductEntry && item.ProductEntry.length > 0 ? (
                                                            <>
                                                                {item.ProductEntry.slice(0, 5).map((entry, index, array) => (
                                                                    <div className="historyBox" key={index}>
                                                                        <p>{entry.ProductName || "NA"}</p>
                                                                        {index !== array.length - 1 && (
                                                                            <Divider className="border__history" />
                                                                        )}
                                                                    </div>
                                                                ))}
                                                                {item.ProductEntry.length > 5 && (
                                                                    <div className="historyBox" style={{ color: '#007bff', textDecoration: 'underline', cursor: 'pointer', fontWeight: 'bold' }} onClick={() => viewInvoice(item)}>
                                                                        <p>Show More</p>
                                                                    </div>
                                                                )}
                                                            </>
                                                        ) : (
                                                            "NA"
                                                        )}
                                                    </TableCell>
                                                    {/* <TableCell>{item?.ProductEntry ? item?.ProductEntry.length > 0 ? <>
                                                        {item?.ProductEntry.map((item) => {
                                                            return (
                                                                <div className="historyBox">
                                                                    <p>{item.BatchNo ? item.BatchNo : "NA"}</p>
                                                                    <Divider className="border__history" />
                                                                </div>
                                                            )
                                                        })}
                                                    </> : 'NA' : 'NA'}</TableCell>
                                                    <TableCell>{item?.ProductEntry ? item?.ProductEntry.length > 0 ? <>
                                                        {item?.ProductEntry.map((item) => {
                                                            return (
                                                                <div className="historyBox">
                                                                    <p>{item.ProductQuantity ? item.ProductQuantity : "NA"}</p>
                                                                    <Divider className="border__history" />
                                                                </div>
                                                            )
                                                        })}
                                                    </> : 'NA' : 'NA'}</TableCell>
                                                    <TableCell>{item?.ProductEntry ? item?.ProductEntry.length > 0 ? <>
                                                        {item?.ProductEntry.map((item) => {
                                                            return (
                                                                <div className="historyBox">
                                                                    <p>{item.ProductMRP ? `Rs.${item.ProductMRP}` : "NA"}</p>
                                                                    <Divider className="border__history" />
                                                                </div>
                                                            )
                                                        })}
                                                    </> : 'NA' : 'NA'}</TableCell> */}
                                                    <TableCell style={{ width: '240px' }}>
                                                        {item.GrossValue ? `Gross Amount: Rs. ${item?.GrossValue}` : "Rs.0"}<br />
                                                        {item.DiscountAmount ? `Discount Amount: Rs. ${item?.DiscountAmount}` : "Rs.0"}<br />
                                                        {item?.BillType == "GST Bill" ? `GST Amount: Rs. ${item?.GSTValue}` : "NA"}<br />
                                                        {item.TotalAmount ? `Total Amount: Rs. ${item.TotalAmount}` : "Rs.0"}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Tooltip title="Edit Invoive" placement="top">
                                                            <IconButton color="primary"
                                                                onClick={() => editInvoice(item)}>
                                                                <EditIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="View Invoice" placement="top">
                                                            <IconButton color="primary"
                                                                onClick={() => viewInvoice(item)}>
                                                                <VisibilityIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        }
                                    </TableBody>
                                </TblContainer>
                                <TblPagination />
                            </div> : <div className="row col-md-12 mt-3 text-center">
                                <img src={NotFound} className="notFound" />
                                <h4>No Sales Bills Record Found!</h4>
                            </div>}
                        </div>
                    </Paper>
                    <Popup openPopup={openPopup} setOpenPopup={setOpenPopup} title="View Invoice" popupSize="lg">
                        {(tableInvoiceRef && tableInvoiceRef != null) && <div>
                            <Button variant="contained" className="employerIndex__createPostBtn employerIndex__createProduct green pr-4" onClick={downloadInvoice} style={{ float: "right", marginBottom: "12px" }}>
                                Download PDF Invoice
                            </Button>
                            <Button 
                                variant="contained" 
                                className="employerIndex__createPostBtn employerIndex__createProduct black pl-5" 
                                onClick={downloadInvoiceinXLSX} 
                                style={{ float: "right", marginBottom: "12px" }}>
                                Download XLSX Invoice
                            </Button>
                            <div ref={tableRef}>
                                <table className="table">
                                    <tr>
                                        <td>
                                            <h5 className="card-events-title product__mainTitle">
                                                {userData?.storeName}
                                            </h5>
                                            {
                                                <p className="card-events-title">
                                                    <b>{userData?.storeAddress}</b>
                                                </p>
                                            }
                                            {
                                                <p className="card-events-title">
                                                    Contact No: <b>{userData?.phoneNumber}</b>
                                                </p>
                                            }
                                            {
                                                <p className="card-events-title">
                                                    Email Id: <b>{userData?.email}</b>
                                                </p>
                                            }
                                            {
                                                <p className="card-events-title">
                                                    GST No: <b>{userData?.gstNo}</b>
                                                </p>
                                            }
                                            {
                                                <p className="card-events-title">
                                                    DL No: <b>{userData?.drugLicense}</b>
                                                </p>
                                            }
                                        </td>
                                        <td>
                                            {(tableInvoiceRef?.storeName || tableInvoiceRef?.chemistEntry?.storeName) && (
                                                <p className="card-events-title">
                                                    Party Name: <b>{tableInvoiceRef?.storeName || tableInvoiceRef?.chemistEntry?.storeName || tableInvoiceRef?.chemistEntry?.name}</b>
                                                </p>
                                            )}
                                            {(tableInvoiceRef?.storeAddress || tableInvoiceRef?.chemistEntry?.storeAddress) && (
                                                <p className="card-events-title">
                                                    Address: <b>{tableInvoiceRef?.storeAddress || tableInvoiceRef?.chemistEntry?.storeAddress}</b>
                                                </p>
                                            )}
                                            {(tableInvoiceRef?.email || tableInvoiceRef?.chemistEntry?.email) && (
                                                <p className="card-events-title">
                                                    Email Id: <b>{tableInvoiceRef?.email || tableInvoiceRef?.chemistEntry?.email}</b>
                                                </p>
                                            )}
                                            {(tableInvoiceRef?.gstNo || tableInvoiceRef?.chemistEntry?.gstNo) && (
                                                <p className="card-events-title">
                                                    GST No: <b>{tableInvoiceRef?.gstNo || tableInvoiceRef?.chemistEntry?.gstNo}</b>
                                                </p>
                                            )}
                                            {(tableInvoiceRef?.drugLicense || tableInvoiceRef?.chemistEntry?.drugLicense) && (
                                                <p className="card-events-title">
                                                    DL No: <b>{tableInvoiceRef?.drugLicense || tableInvoiceRef?.chemistEntry?.drugLicense}</b>
                                                </p>
                                            )}
                                            {tableInvoiceRef?.InvoiceNo && (
                                                <p className="card-events-title">
                                                    Invoice No: <b>{tableInvoiceRef?.InvoiceNo}</b>
                                                </p>
                                            )}
                                            {tableInvoiceRef?.InvoiceDate && (
                                                <p className="card-events-title">
                                                    Invoice Date: <b>{tableInvoiceRef?.InvoiceDate}</b>
                                                </p>
                                            )}
                                        </td>
                                    </tr>
                                </table>
                                <table className="table" ref={xlsxTableRef}>
                                    <thead>
                                        <tr>
                                            <td>S.No</td>
                                            <td>Particulars</td>
                                            <td>Pack Size</td>
                                            <td>Quantity</td>
                                            <td>Exp Date</td>
                                            <td>HSN Code</td>
                                            <td>Batch No</td>
                                            <td>MRP</td>
                                            {tableInvoiceRef?.BillType === "GST Bill" && <td>Tax</td>}
                                            <td>Discount</td>
                                            <td>Rate</td>
                                            <td>Amount</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tableInvoiceRef &&
                                            tableInvoiceRef?.ProductEntry &&
                                            tableInvoiceRef?.ProductEntry?.length > 0 &&
                                            tableInvoiceRef?.ProductEntry.map((item, index) => {
                                                let TotalAmount = item?.Rate * extractNumber(item?.ProductQuantity);
                                                return (
                                                    <tr>
                                                        <td>{index + 1}</td>
                                                        <td>{item?.ProductName}</td>
                                                        <td>{item?.PackagingSize}</td>
                                                        <td>{item?.ProductQuantity}</td>
                                                        <td>{item?.ExpiryDate ? item?.ExpiryDate : 'NA'}</td>
                                                        <td>{item?.HSNCode ? item?.HSNCode : "NA"}</td>
                                                        <td>{item?.BatchNo ? item?.BatchNo : "NA"}</td>
                                                        <td>
                                                            {item?.ProductMRP
                                                                ? `Rs. ${item?.ProductMRP}`
                                                                : '0'}
                                                        </td>
                                                        {tableInvoiceRef?.BillType === "GST Bill" && <td>{`${item?.Tax}`}</td>}
                                                        <td>{item?.DiscountAmount}</td>
                                                        <td>{item?.Rate}</td>
                                                        <td>{`Rs. ${TotalAmount?.toFixed(2)}`}</td>
                                                    </tr>
                                                )
                                            })}
                                        <tr>
                                            <td colSpan={tableInvoiceRef?.BillType === "GST Bill" ? 10 : 9}></td>
                                            <td>Gross Amount</td>
                                            <td>{`Rs. ${tableInvoiceRef?.GrossValue}`}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan={tableInvoiceRef?.BillType === "GST Bill" ? 10 : 9}></td>
                                            <td>Total Discount</td>
                                            <td>{`Rs. ${tableInvoiceRef?.DiscountAmount}`}</td>
                                        </tr>
                                        {tableInvoiceRef?.BillType === "GST Bill" && <tr>
                                            <td colSpan={10}></td>
                                            <td>Total GST</td>
                                            <td>{`Rs. ${tableInvoiceRef?.GSTValue}`}</td>
                                        </tr>}
                                        {tableInvoiceRef?.BillType === "GST Bill" && <tr>
                                            <td colSpan={10}></td>
                                            <td>CGST</td>
                                            <td>{`Rs. ${(tableInvoiceRef?.GSTValue / 2).toFixed(2)}`}</td>
                                        </tr>}
                                        {tableInvoiceRef?.BillType === "GST Bill" && <tr>
                                            <td colSpan={10}></td>
                                            <td>SGST</td>
                                            <td>{`Rs. ${(tableInvoiceRef?.GSTValue / 2).toFixed(2)}`}</td>
                                        </tr>}
                                        <tr>
                                            <td colSpan={tableInvoiceRef?.BillType === "GST Bill" ? 10 : 9}>
                                                Account Holder:	Butame Pharma Pvt Ltd	<br />
                                                Account No:		10084890331	<br />
                                                Account Type:		Current Acount <br />
                                                Bank Name:		IDFC First Bank <br />
                                                Bank IFSC Code:		IDFB0020132
                                            </td>
                                            <td><b>Net Total</b> </td>
                                            <td>{`Rs. ${tableInvoiceRef?.TotalAmount}`}</td>
                                        </tr>
                                        <tr></tr>
                                        {tableInvoiceRef?.BillType === "GST Bill" && <tr>
                                            <td colSpan={12}>
                                                Note: We do not entertain any credit based supply of the goods.<br />
                                                Please return the damaged or expired products to the delivery boy at the same time.<br />
                                                For queries, contact us at: hello@kaipsool.com
                                            </td>
                                        </tr>}
                                    </tbody>
                                </table>
                            </div>
                        </div>}
                    </Popup>

                </div>)
            }
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType || 'error'}
                notificationMessage={notificationMessage} />
        </>
    )
}

export default SupplyOrderBillsHistory
